<div class="flip-card" [class.flipped]="liveIncidentsFlipped">
  <div class="insights-flip-card-inner">
    <!-- Front Side -->
    <div class="flip-card-front">
      <i class="fa fa-list" (click)="flipLiveIncidents()" aria-hidden="true"></i>
      <div id="second-block" class="card-block dark">
        <div class="card-wrap">
          <div [style.minHeight.px]="75" class="custom-mb">
            <app-incidents-till-now [data]="incidentsData"></app-incidents-till-now>
          </div>
          <div class="d-flex flex-column" [style.minHeight]="realTimeMinHeight+'vh'">
            <app-realtime-alarms class="d-flex flex-column flex-grow-1"></app-realtime-alarms>
          </div>
        </div>
      </div>
    </div>
    <!-- Back Side -->
    <div class="alarm-progress-flip-card-back">
      <app-action-history [alarm]="selectedAlarm"></app-action-history>
      <mat-icon class="insights-flip-icon" (click)="flipLiveIncidents()">trending_up</mat-icon>
    </div>
  </div>
</div>